import React from 'react';
import { useNavigate } from 'react-router-dom';
import EyeIcon from '@mui/icons-material/VisibilityOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { useSelector } from 'react-redux';

import { API_DOMAIN } from '../../../../constants';
import { IGuestCartItem } from '../interfaces';
import { thousands } from '../../../../utils/utils';
import { useCartItemsStyles } from '../hooks/useCartItemsStyles.';
import { useFormatMessage } from '../../../../hooks';
import { CartCounter } from './CartCounter';
import { PriceValue } from '../../../../interfaces/product';
import { calculatePrice } from '../utils';
import { selectIsAdmin } from '../selectors';

const CartItemGuest: React.FC<{
  setCountGuestCart: (data: {
    product_id: number;
    count: number;
    type: 'dec' | 'inc';
    priceValue?: PriceValue;
  }) => void;
  handleImage?: (url?: string) => void;
  itemGuestCart: IGuestCartItem;
  isLastItem?: boolean;
}> = ({ setCountGuestCart, handleImage, itemGuestCart, isLastItem }) => {
  const classes = useCartItemsStyles();
  const navigate = useNavigate();
  const fm = useFormatMessage();
  const isAdmin = useSelector(selectIsAdmin);
  const priceData = calculatePrice(itemGuestCart.count, itemGuestCart.priceValue?.prices);
  const price = priceData || itemGuestCart.product.price || 0;

  return (
    <div className={classes.cardContent}>
      <div
        className={classes.contentWrapper}
        style={{
          borderBottom: isLastItem ? 'none' : '1px solid #7c97c033',
        }}
      >
        <div className={classes.containerImage}>
          {itemGuestCart.product.photos && itemGuestCart.product.photos.length > 0 ? (
            <img
              alt=''
              onClick={() =>
                itemGuestCart.product.photos &&
                handleImage &&
                handleImage(
                  `${API_DOMAIN}/${
                    itemGuestCart?.product?.photos?.find(el => el.main)?.small ||
                    itemGuestCart.product.photos[0].small ||
                    ''
                  }`
                )
              }
              src={`${API_DOMAIN}/${
                itemGuestCart?.product?.photos?.find(el => el.main)?.small ||
                itemGuestCart.product.photos[0].small
              }`}
              className={classes.img}
            />
          ) : (
            <img alt='' src='../../../images/placeholder.png' className={classes.img} />
          )}
        </div>

        <div className={classes.infoWrapper}>
          <div className={classes.cardTopRow}>
            <div
              className={classes.deleteButtonCorner}
              onClick={() => {
                setCountGuestCart({
                  product_id: itemGuestCart.product.id || 0,
                  count: 0,
                  type: 'dec',
                  priceValue: itemGuestCart.priceValue,
                });
              }}
            >
              <DeleteIcon sx={{ fontSize: 19, color: '#7c97c0' }} />
              <b className={classes.btnIconTitle}>{fm('COMMON.BUTTON.DELETE')}</b>
            </div>
          </div>
          <div className={classes.infoButtonsWrapper}>
            <div className={classes.containerProduct}>
              <b className={classes.productName}>{itemGuestCart.product.name}</b>
              <div className={classes.containerPrice}>
                <b
                  className={classes.priceProduct}
                >{`${price} ₽ x ${itemGuestCart.count} шт =`}</b>
                <b className={classes.priceTotal}>
                  {price * itemGuestCart.count === 0
                    ? 0
                    : thousands(String((price * itemGuestCart.count).toFixed(2)))}{' '}
                  руб.
                </b>
              </div>
            </div>

            <div className={classes.buttonsWrapper}>
              <div
                className={classes.containerButton}
                onClick={() => {
                  navigate(
                    isAdmin
                      ? `/products/edit/${itemGuestCart.product.id}`
                      : `/viewproduct/${itemGuestCart.product.id}`
                  );
                }}
              >
                <EyeIcon sx={{ fontSize: 19, color: '#7c97c0' }} />
                <b className={classes.btnIconTitle}>{fm('VIEW')}</b>
              </div>
              <CartCounter item={itemGuestCart} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemGuest;
